module.exports = __webpack_public_path__ + "c02aab14d1e331520e9b44952d5a8535.svg";